import React from "react"
import FarmerExportScreen from "../../screen/FarmerExportScreen"
import { exportUsersProject } from "../../core/utils/exports"

const FarmerExportContainer = ({ selectedsUsers }) => {
  const {exportUsers, loadingExport} = exportUsersProject(selectedsUsers, 'users_data_all_')
  
  return (
    <FarmerExportScreen {...{exportUsers, loadingExport}}/>
  )
}

export default FarmerExportContainer
